<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
    <DialogSendEMail ref="dialog"/>
    <DialogSendEMailRegister ref="dialogRegister"/>

    <v-container style="margin-bottom: 6em;">
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card flat color="transparent">
            <v-card-title class="headline font-weight-thin bluetext mt-1">
              {{'TITLE_CONTACT' | translate}}
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card flat color="transparent">
            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                sm6
                class="px-2"
              >

                <v-select
                  :items="items"
                  :label="salution"
                  v-model="formData.anrede"
                  :rules="[rules.required]"
                  solo
                  class="heightLogin"
                  required
                ></v-select>
              </v-flex>

              <v-flex
                xs12
                sm6
                class="px-2"
              >
              </v-flex>
            </v-layout>

            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field solo class="heightLogin" :label="forname" v-model="formData.forname"
                              :rules="[rules.required]"
                              required>
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field solo class="heightLogin" :label="name" required
                              v-model="formData.nachname"
                              :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field
                  solo class="heightLogin" :label="business" required v-model="formData.firma"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field
                  solo class="heightLogin" :label="position" required v-model="formData.pos"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field
                  solo class="heightLogin inputPrice" :label="zip" required v-model="formData.plz"
                  :rules="[rules.required]"
                  type="number"
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field
                  solo class="heightLogin" :label="town" required v-model="formData.stadt"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                class="px-2"
              >

                <v-select
                  :items="itemsvia"
                  :label="contactme"
                  :rules="[rules.required]"
                  solo
                  v-model="formData.kontaktArt"
                  class="heightLogin"
                  required
                ></v-select>
              </v-flex>

              <v-flex
                xs12
                sm6
                class="px-2"
              >
              </v-flex>
            </v-layout>

            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field solo class="heightLogin" :label="mail" :rules="emailRules" required
                              v-model="formData.email"
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm6
                class="px-2"
              >
                <v-text-field solo class="heightLogin inputPrice" :label="phonenumber"
                              v-model="formData.telefon" type="text"
                              :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
            </v-layout>


            <v-flex
              xs12
              sm12
              class="px-2"
            >
              <v-textarea
                solo
                class="heightLogin"
                v-model="formData.nachricht"
                :rules="[rules.required]"
                :label="yourmessage"
              ></v-textarea>
            </v-flex>
            <v-layout row class="mb-3">
              <v-flex xs12>
                <v-checkbox
                  :rules="[rules.required]"
                  color="#004884"
                  v-model="formData.agree"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      {{'CHECKBOX_LEGALNOTICE1' | translate}}
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="https://www.creditreform.de/datenschutz"
                            @click.stop
                            v-on="on"
                          >
                            {{'LEGALNOTICE' | translate}}
                          </a>
                        </template>
                        {{'TOOLTIP_LEGALNOTICE' | translate}}
                      </v-tooltip>
                      {{'CHECKBOX_LEGALNOTICE2'| translate}}
                      <a
                        href="mailto:info@creditreform-rating.de"
                        @click.stop
                      >
                        {{'EMAIL_LEGALNOTICE' | translate}}
                      </a>
                      {{'CHECKBOX_LEGALNOTICE3'| translate}}
                    </div>
                  </template>


                </v-checkbox>


              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-layout>
                <v-btn color="blue" dark small class="font-weight-bold text-none" @click="goPortal">
                  {{'BUTT_BACK' | translate}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue" dark small class="font-weight-bold text-none" @click="onSubmit">
                  {{'BUTT_SEND' | translate}}
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<!-- um dei Text Felder wieder rund zubekommen folgende KLasse hinzufügen : my-input -->

<script>
import Vue from 'vue'
// import VueRecaptcha from 'vue-recaptcha'
import DialogSendEMail from './../module/dialogs/DialogSendEMail'
import DialogSendEMailRegister from './../module/dialogs/DialogSendEMailRegister'
export default {
  name: 'ContactForm',
  components: {DialogSendEMail,DialogSendEMailRegister},
  props: ['formType'],
  methods: {
    goPortal: function () {
      this.$router.push('/Login')
    },
    onClick: function () {
      window.history.back()
    },
    onSubmit: function () {
      if (!this.$refs.form.validate()) {
        Vue.prototype.$api.debug('missing values')
        return
      }
      Vue.prototype.$api.debug('doSend')
      this.onVerify('noCaptcha')
    },
    onVerify: function (response) {
      Vue.prototype.$api.debug('Verify: ' + response)
      Vue.prototype.$api.register(response, this.formData, this.onRegister)
    },
    onRegister: function () {
      if (this.formType === 'register') {
        this.$refs.dialogRegister.open()
      } else {
        this.$refs.dialog.open()
      }

    },
    onExpired: function () {
      Vue.prototype.$api.debug('Expired')
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    }
  },
  data () {
    return {
      formData: {
        anrede: '',
        vorname: '',
        nachname: '',
        firma: '',
        pos: '',
        plz: '',
        agree: false,
        stadt: '',
        kontaktArt: '',
        email: '',
        telefon: '',
        nachricht: ''
      },
      LegalNotice: Vue.i18n.translate('CHECKBOX_LEGALNOTICE'),
      valid: true,
      lazy: false,
      salution: Vue.i18n.translate('SALUTION'),
      forname: Vue.i18n.translate('FORM_FORNAME'),
      name: Vue.i18n.translate('FORM_NAME'),
      business: Vue.i18n.translate('FORM_BUSINESS'),
      position: Vue.i18n.translate('FORM_POSITION'),
      zip: Vue.i18n.translate('FORM_ZIP'),
      town: Vue.i18n.translate('FORM_TOWN'),
      contactme: Vue.i18n.translate('FORM_CONTACTME'),
      mail: Vue.i18n.translate('FORM_MAIL'),
      phonenumber: Vue.i18n.translate('FORM_PHONENUMBER'),
      yourmessage: Vue.i18n.translate('FORM_YOURMESSAGE'),
      items: [Vue.i18n.translate('FORM_MR'), Vue.i18n.translate('FORM_MRS')],
      itemsvia: [Vue.i18n.translate('FORM_PHONE'), Vue.i18n.translate('FORM_MAIL')],
      email: '',
      emailRules: [
        v => /.+@.+/.test(v) || Vue.i18n.translate('FORM_MAILRULE')
      ],
      rules: {
        required: value => !!value || Vue.i18n.translate('FORM_REQUIRED')
      }
    }
  },
  mounted () {
    // Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/ContactForm.vue